// @flow

import * as React from 'react';
import { useTranslate } from '@insolus/react-i18n';
import { Select } from '@insolus/ui-kit';

import type { UrlCriteria } from 'utils/_types';

type Props = {|
    criteria: UrlCriteria,
    onSearch: (value: string) => void
|};

const SearchSort = ({ criteria, onSearch }: Props): React.Node => {
    const { __ } = useTranslate();

    const options = [
        {
            label : __('sort-ascending-expiration-date'),
            value : 'dat:asc'
        },
        {
            label : __('sort-descending-expiration-date'),
            value : 'dat:desc'
        },
        {
            label : __('sort-ascending-price'),
            value : 'pri:asc'
        },
        {
            label : __('sort-descending-price'),
            value : 'pri:desc'
        }
    ];

    const { sortType, sortDirection }: UrlCriteria = criteria;
    const defaultSort = `${sortType ??
        'dat'
    }:${sortDirection ??
        'desc'
    }`;

    return (
        <Select
            name="searchSort"
            options={options}
            defaultValue={defaultSort}
            onChange={onSearch}
            clearable={false}
        />
    );
};

export default SearchSort;
